import { useEffect, useState } from 'react';

export const useScheduleExpired = (scheduleTo?: string) => {
    const [isExpired, setIsExpired] = useState(false);
    useEffect(() => {
        if (!scheduleTo) return;

        const checkExpired = () => {
        const today = new Date();
        const scheduleDate = new Date(scheduleTo);

        // Normalize both dates to ignore time
        today.setHours(0, 0, 0, 0);
        scheduleDate.setHours(0, 0, 0, 0);

        setIsExpired(today >= scheduleDate);
        };

        checkExpired(); // initial check

        const interval = setInterval(checkExpired, 60 * 1000); // check every minute
        return () => clearInterval(interval);
    }, [scheduleTo]);

    return isExpired;
};

export const useScheduleExpiredButHasUpdate = (scheduleTo?: string) => {
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        if (!scheduleTo) return;

        const checkExpired = () => {
        const now = new Date();

        const scheduleDate = new Date(scheduleTo);

        // Add 1-day grace period keeping the exact time
        const graceDate = new Date(scheduleDate);
        graceDate.setDate(graceDate.getDate() + 1);

        setIsExpired(now > graceDate);
        };

        checkExpired();

        const interval = setInterval(checkExpired, 60 * 1000); // check every minute
        return () => clearInterval(interval);
    }, [scheduleTo]);

    return isExpired;
};